import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/components/DifficultConditions/DifficultConditions.tsx";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
import { ClickAwayListener } from '@mui/material';
import { useStore, useStoreMap } from 'effector-react';
import { getSourceGroupId } from "../../../../classifier-editor/ImportEstimation/helpers/getSourceGroupId";
import { useElementPropertyList } from "../../helpers/useElementPropertyList";
import { importEstimationService } from "../../../../classifier-editor/ImportEstimation/model";
import { ConditionItem } from "./ConditionItem";
import { ConditionsContainer, Header, HeaderTitle } from "./DifficultConditions.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DifficultConditions = /*#__PURE__*/React.memo(function (_ref) {
  var _activeEstimation$cal, _activeEstimation$cal2;

  var currentGroup = _ref.currentGroup,
      readonly = _ref.readonly;
  var groupId = getSourceGroupId(currentGroup);
  var activeEstimation = useStore(importEstimationService.activeEstimation$, {
    loc: {
      file: _effectorFileName,
      line: 51,
      column: 29
    },
    name: "DifficultConditions",
    sid: "DifficultConditions /src/classifier-editor/ImportEstimation/components/DifficultConditions/DifficultConditions.tsx [51, 29]"
  });
  var calculationId = activeEstimation === null || activeEstimation === void 0 ? void 0 : (_activeEstimation$cal = activeEstimation.calculations) === null || _activeEstimation$cal === void 0 ? void 0 : (_activeEstimation$cal2 = _activeEstimation$cal.find(function (calculation) {
    return groupId === calculation.groupId;
  })) === null || _activeEstimation$cal2 === void 0 ? void 0 : _activeEstimation$cal2.id;
  var complexFields = useStoreMap({
    store: importEstimationService.activeEstimation$,
    keys: [groupId],
    fn: function fn(activeEstimation, _ref2) {
      var _activeEstimation$cal3, _activeEstimation$cal4;

      var _ref3 = _slicedToArray(_ref2, 1),
          groupId = _ref3[0];

      return groupId && activeEstimation ? (activeEstimation === null || activeEstimation === void 0 ? void 0 : (_activeEstimation$cal3 = activeEstimation.calculations) === null || _activeEstimation$cal3 === void 0 ? void 0 : (_activeEstimation$cal4 = _activeEstimation$cal3.find(function (calculation) {
        return calculation.groupId === groupId;
      })) === null || _activeEstimation$cal4 === void 0 ? void 0 : _activeEstimation$cal4.complexFields.map(function (condition) {
        return _objectSpread({
          initialFormula: condition.formula,
          errorName: ''
        }, condition);
      })) || [] : [];
    }
  });
  var complexFieldsProperties = useStoreMap({
    store: importEstimationService.activeEstimation$,
    keys: [groupId],
    fn: function fn(activeEstimation, _ref4) {
      var _activeEstimation$cal5, _activeEstimation$cal6;

      var _ref5 = _slicedToArray(_ref4, 1),
          groupId = _ref5[0];

      return groupId && activeEstimation ? (activeEstimation === null || activeEstimation === void 0 ? void 0 : (_activeEstimation$cal5 = activeEstimation.calculations) === null || _activeEstimation$cal5 === void 0 ? void 0 : (_activeEstimation$cal6 = _activeEstimation$cal5.find(function (calculation) {
        return calculation.groupId === groupId;
      })) === null || _activeEstimation$cal6 === void 0 ? void 0 : _activeEstimation$cal6.complexFieldsProperties) || [] : [];
    }
  });

  var _useElementPropertyLi = useElementPropertyList(),
      propertyElementList = _useElementPropertyLi.propertyElementList; // eslint-disable-next-line no-empty-function


  var onClickAway = function onClickAway() {};

  var onValidate = React.useCallback(function () {
    return true;
  }, []);
  return /*#__PURE__*/_jsx(ClickAwayListener, {
    onClickAway: onClickAway,
    touchEvent: "onTouchStart",
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Header, {
        children: /*#__PURE__*/_jsx(HeaderTitle, {
          children: "\u0412\u044B\u0447\u0438\u0441\u043B\u0438\u043C\u044B\u0435 \u043A\u043E\u043B\u043E\u043D\u043A\u0438"
        })
      }), propertyElementList.length ? /*#__PURE__*/_jsx(ConditionsContainer, {
        children: complexFields === null || complexFields === void 0 ? void 0 : complexFields.map(function (condition, idx) {
          return /*#__PURE__*/_jsx(ConditionItem // eslint-disable-next-line react/no-array-index-key
          , {
            allSuggestions: propertyElementList,
            formula: condition.initialFormula,
            suggestionsInFormula: complexFieldsProperties,
            name: condition.name,
            unit: condition.unit,
            onValidate: onValidate,
            readonly: readonly,
            idx: idx,
            calculationId: calculationId,
            errorName: condition.errorName
          }, "".concat(groupId, "__").concat(idx));
        })
      }) : null]
    })
  });
});
DifficultConditions.displayName = 'DifficultConditions';